import { render } from "./AddUserMsisdnDialog.vue?vue&type=template&id=510437bc&scoped=true"
import script from "./AddUserMsisdnDialog.vue?vue&type=script&lang=js"
export * from "./AddUserMsisdnDialog.vue?vue&type=script&lang=js"

import "./AddUserMsisdnDialog.vue?vue&type=style&index=0&id=510437bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510437bc"]])

export default __exports__